/**
 * Counts the number of occurrences of a given key in an array of objects and returns an array of objects,
 * each containing the key name and its corresponding count.
 *
 * @param {T[]} arrData - An array of objects.
 * @param {keyof T} valueToCount - The key name whose occurrences are to be counted.
 * @returns {({name: string, count: number}[]) } - An array of objects, each containing a name and its corresponding count.
 */


export function countSimilarKeys<T>(
  arrData: T[],
  valueToCount: keyof T,
): { name: string; count: number }[] {
  if (arrData.length === 0) return [];

  const countObj: Record<string, number> = {};

  arrData.forEach((item) => {
    const value = item[valueToCount];
    const key = String(value ?? ''); // Convert to string, handle null/undefined
    if (countObj[key]) {
      countObj[key]++;
    } else {
      countObj[key] = 1;
    }
  });

  const result: { name: string; count: number }[] = Object.entries(
    countObj,
  ).map(([key, value]) => ({ name: key, count: value }));

  return result;
}
